import { useState, useEffect } from "react";
import TeenBanner from "@/components/TeenBanner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Packages from "@/components/Packages";
import Booking from "@/components/Booking";
import Gallery from "@/components/Gallery";
import FeaturedCar from "@/components/FeaturedCar";
import Testimonials from "@/components/Testimonials";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { toast } from "sonner";

export default function Home() {
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("canceled") === "1") {
      toast.error("Payment canceled. Your booking was not completed.");
      window.history.replaceState({}, "", "/");
    }
  }, []);

  const handleSelectPackage = (pkgId) => {
    setSelectedPackage(pkgId);
    const el = document.getElementById("booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#FDF9F3] text-[#3D2E1C] font-sans">
      <TeenBanner />
      <Navbar />
      <Hero />
      <Packages onSelect={handleSelectPackage} />
      <Booking selectedPackage={selectedPackage} onChangePackage={setSelectedPackage} />
      <Gallery />
      <FeaturedCar />
      <Testimonials />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
